export class TiresBySpecsParamsModel {
  season: string;
  width: number;
  aspectRatio: number;
  diameter: number;
}
